export var CURRENCY_CODE_CONTAINER_WIDTH = 64;